<template>
  <div>
    <CRow class="content-fade-in">
      <CCol md="12">
        <CCard>
          <CCardBody>
            <CForm class="form-basic" v-if="$hasAuthor('ROLE_ADMIN')">
              <CRow>
                <CCol sm="6" md="6" xl="6">
                  <div class="form-input-wrapper">
                    <div class="form-group">
                      <label class="form-label" for="uploadFile">Chọn tài liệu<span class='required'> *</span></label>
                      <div class="custom-file"
                        :class="selectedFiles.data.validator.isValid == false ? 'input-valid-error' : ''">
                        <input type="file" class="custom-file-input" id="uploadFile" ref="file" accept=".pdf"
                          @change="selectFile($event)">
                        <label class="custom-file-label" for="uploadFile">{{ fileName }}</label>
                      </div>
                      <div class="valid-error"
                        v-show="!(selectedFiles.data.validator ? selectedFiles.data.validator.isValid : true)">
                        {{ selectedFiles.data.validator ? selectedFiles.data.validator.errorMessage : "" }}
                      </div>
                    </div>
                  </div>
                </CCol>
              </CRow>
              <div slot="footer" class="mt-4">
                <CButton color="primary" class="btn-action-primary mr-2" @click="submitData()">
                  <i class="fa fa-save"></i> Lưu lại
                </CButton>
              </div>
              <BaseLoading :loading="loading.value"></BaseLoading>
            </CForm>
            <br />
            <CButton color="success" class="btn-action-primary mr-2" @click="downloadUserManual()">
              <i class="fa fa-download"></i> Tải hướng dẫn sử dụng
            </CButton>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import BaseSelect from "@/views/base/BaseSelect2";
import BaseInput from "@/views/base/BaseInput";
import BaseLoading from "@/views/base/BaseFormLoading";
import BaseTextArea from "@/views/base/BaseTextArea.vue";

export default {
  name: "UserManual",
  components: { BaseSelect, BaseInput, BaseLoading, BaseTextArea },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success"
    },
    showErrorMsg: {
      type: "error",
      title: "Errors"
    },
    showWarningMsg: {
      type: "warn",
      title: "warn"
    }
  },
  data: function () {
    let that = this;
    return {
      loading: { value: false },
      url: null,
      fileName: 'Chọn tệp',
      selectedFiles: {
        data: {
          name: "file",
          model: {
            fileName: '',
            content: ''
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.selectedFiles.data.model.fileName;
              if (value.length == 0) {
                this.isValid = false;
                this.errorMessage = "Tài liệu không được để trống";
              } else {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            }
          }
        }
      }
    }
  },
  methods: {
    submitData: function () {
      let that = this;
      this.$helper.loadDataSource({
        loading: that.loading,
        url: "/document/user-manual",
        dataRef: function () {
          return that.$data;
        },
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({ message: that.$helper.getStringError(response.data.data) });
            that.$helper.setupErrorModel(response.data.data, that.$data);
          } else {
            that.showSuccessMsg({
              message: "Cập nhật hướng dẫn sử dụng thành công"
            });
            // that.$router.push('/document-management/managed-document.html')
            window.location.reload()
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
    selectFile() {
      let that = this;
      let reader = new FileReader();
      var file = this.$refs.file.files[0];
      if (file) {
        if (file.type == 'application/pdf') {
          that.fileName = file.name;
          reader.readAsDataURL(file);
          reader.onload = function () {
            setTimeout(function () {
              that.selectedFiles.data.model.fileName = file.name;
              that.selectedFiles.data.model.content = reader.result.split(',')[1];
            }, 500)
          }
        } else {
          that.showErrorMsg({ message: 'Vui lòng chọn tệp tin có đuôi .pdf' });
        }
      }
    },
    getUserManual() {
      let that = this;
      that.$helper.loadDataSource({
        loading: that.loading,
        url: "/document/get-user-manual",
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.loading.value = false;
            that.showErrorMsg({ message: that.$helper.getStringError(response.data.data) });
            that.$helper.setupErrorModel(response.data.data, that.$data);
          } else {
            that.url = response.data.data;
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
    async downloadUserManual() {
      let that = this;
      if (that.url == null || that.url == '' || that.url.length == 0 || that.url == 'undefined') {
        that.showErrorMsg({ message: 'Chưa có hướng dẫn sử dụng' });
      } else {
        that.loading.value = true;
        const data = await that.$helper.blobFileByUrl(that.url);
        setTimeout(() => {
          that.loading.value = false;
          window.open(data);
        }, 500);
      }
    }
  },
  computed: {},
  created() {
  },
  mounted() {
    this.getUserManual();
  },
  watch: {
  }
};
</script>
